//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  name: "emailLogin",
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      pagingReqFn: "emailList",
      paramsData: {
        isMustAppid: 1
      },
      columns: []
    };
  },
  created: function created() {},
  activated: function activated() {
    this.getcommonData(['appListAllData']);
  },
  methods: {
    exportDataFn: function exportDataFn() {
      this.columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '网关用户ID',
        prop: 'gate_user_id'
      }, {
        label: 'email',
        prop: 'email'
      }, {
        label: '创建时间',
        prop: 'create_time'
      }];
      this.exportData();
    }
  }
};